import {FileDownloadService} from '@services/file-download.service';
import {DownloadRelatorioService} from '@services/download-relatorio.service';
import {Component, ChangeDetectionStrategy} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import {TrocarEmpresaService} from '@services/trocar-empresa.service';
import {UsuarioPermissaoService} from '@services/usuario-permissao.service';
import {TermoService} from '@services/termo.service';
import {LoginService} from '@services/login.service';
import {take} from 'rxjs/operators';
import {GoogleTagManagerEventEnum} from 'src/app/enums/GoogleTagManagerEvent.enum';
import {GoogleTagManagerModel} from 'src/app/models/google-tag-manager.model';
import {HttpResponse} from '@angular/common/http';
import {Wso2Service} from '@services/wso2.service';
import {PolicyTermService} from '@services/policy-term.service';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { TagManagerDirective } from '../../directives/tag-manager.directive';
import { NotificacoesDropdownComponent } from './notificacoes-dropdown/notificacoes-dropdown.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { CamelCasePipe } from '../../pipes/camel-case.pipe';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { UsuarioPermissaoPipe } from '../../pipes/usuario-permissao.pipe';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, RouterLink, TagManagerDirective, NotificacoesDropdownComponent, NgClass, AsyncPipe, CamelCasePipe, CnpjPipe, UsuarioPermissaoPipe]
})
export class HeaderComponent {
  public cnpj: string;
  public nomeEmpresa: string;
  public LoadingGenerico = false;
  public username: string = sessionStorage.username;
  public empresa: any = localStorage.idEmpresaLogada;

  constructor(
    private readonly trocarEmpresaService: TrocarEmpresaService,
    public rota: Router,
    private readonly loginService: LoginService,
    public usuarioPermissaoService: UsuarioPermissaoService,
    private readonly downloadRelatorioService: DownloadRelatorioService,
    private readonly wso2Service: Wso2Service,
    private readonly policyService: PolicyTermService,
    private readonly termoService: TermoService,
  ) {
    this.verificaUsuarioLogado();
  }

  verificaUsuarioLogado() {
    const usuarioLogado = this.loginService.checkCredentials();
    if (usuarioLogado) {
      this.cnpj = localStorage.cnpj;
      this.nomeEmpresa = localStorage.nomeEmpresa;
      this.trocarEmpresaService.subject.subscribe((success: any) => {
        this.cnpj = success.cnpj;
        this.nomeEmpresa = success.nomeEmpresa;
      });
    } else {
      this.rota.navigate(['login']);
    }
  }

  sairDoSistema() {
    sessionStorage.setItem('logoff', 'true');
    sessionStorage.removeItem('usuarioLogado');
    this.loginService.logout();

  }

  public downloadTermoAdesao() {
    this.LoadingGenerico = true;

    this.termoService.downloadTermoPdf(this.empresa).subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.LoadingGenerico = false;
        const filename = 'Recarga Certa - Termo de Adesão.pdf';
        FileDownloadService.download([body], filename);
      },
      error: () => {
        this.LoadingGenerico = false;
      }
    });
  }

  public downloadTermoUtilizacao() {

    this.LoadingGenerico = true;

    this.downloadRelatorioService.downloadTermoUtilizacao(this.empresa).pipe(take(1)).subscribe({
      next: ({body, headers}: HttpResponse<any>) => {
        this.LoadingGenerico = false;

        const filename = 'Roteirização - Termo de Utilização.pdf';
        FileDownloadService.download([body], filename);
      },
      error: () => {
        this.LoadingGenerico = false;
      }
    });
  }

  openPrivacyPolicy() {
    this.policyService.openPrivacyPolicy();
  }


  addTagManagerInteraction(elementType: string, elementContent: string): GoogleTagManagerModel {
    return this.addTagManager(GoogleTagManagerEventEnum.interaction, elementType, elementContent);
  }

  private addTagManager(event: GoogleTagManagerEventEnum, elementType: string, elementContent: string): GoogleTagManagerModel {
    const model: GoogleTagManagerModel = new GoogleTagManagerModel();
    model.event = event;
    model.element_type = elementType;
    model.element_content = `none:${elementContent}:none`;
    model.section_app = 'painel-de-controle';
    model.screen_name = 'painel-de-controle:home';
    model.screen_type = 'pagina';
    return model;
  }

  privacidadeSeguranca() {
    this.wso2Service.redirectToPrivacidadeESeguranca();
  }

}
